import React from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet'
import { Input, InputGroup, InputRightAddon } from '@wartek-id/input'
import { Button } from '@wartek-id/button-v1'
import {
  HeaderBar,
  HeaderBarTitle,
  HeaderBarLeftAction,
} from '@wartek-id/header-bar'

import { getClassesByPhase } from 'app/AssessmentPage/utils/class'
import SubjectFilterResult from './SubjectFilterResult'

import type { TFase, TFaseGroup } from 'types/classAndPhases'

interface MapelSheetProps {
  close: () => void
  isOpen: boolean
  selectedFase: TFase
  selectedFaseGroup: TFaseGroup
  selectedSubject: string
  setSelectedSubject: (subject: string) => void
}

const MapelSheet = ({
  close,
  isOpen,
  selectedFase,
  selectedFaseGroup,
  selectedSubject,
  setSelectedSubject,
}: MapelSheetProps) => {
  const [keyword, setKeyword] = React.useState('')
  const [internalSelectedSubject, setInternalSelectedSubject] =
    React.useState<string>(selectedSubject)
  const isShowButton = !!internalSelectedSubject
  const headerBarSubtitle = React.useMemo(() => {
    let subtitle = ''

    if (selectedFase) {
      const classFromPhase = getClassesByPhase(selectedFase)?.map((klass) =>
        klass?.replace('Kelas ', '')
      )
      subtitle += `Fase ${selectedFase}`
      subtitle += ' • Kelas '
      if (classFromPhase?.length === 1) {
        subtitle += classFromPhase?.[0]
        return subtitle
      }
      if (classFromPhase?.length === 2) {
        subtitle += classFromPhase?.join('-')
        return subtitle
      }

      const firstAndLastClasses = [
        classFromPhase?.[0],
        classFromPhase?.[classFromPhase?.length - 1],
      ]
      subtitle += firstAndLastClasses?.join('-')
    }
    return subtitle
  }, [selectedFase])

  React.useEffect(() => {
    if (isOpen) {
      setKeyword('')
      setInternalSelectedSubject(selectedSubject)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  return (
    <Sheet isOpen={isOpen} onClose={close} position="bottom" sheetSize="full">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <HeaderBar className="!sticky !top-0 !overflow-visible">
          <HeaderBarLeftAction onClick={close} icon={<Icon>close</Icon>} />
          <HeaderBarTitle subtitle={headerBarSubtitle}>
            Pilih Mata Pelajaran
          </HeaderBarTitle>
        </HeaderBar>
        <div
          className={clsx(
            'h-full min-h-[calc(100vh-70px)] px-4 pb-4',
            isShowButton ? 'mb-[80px] min-h-[calc(100vh-118px)]' : ''
          )}
        >
          <div className="sticky top-0 bg-white pt-4">
            <InputGroup>
              <Input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder={`Cari mata pelajaran`}
              />
              <InputRightAddon style={{ pointerEvents: 'auto' }}>
                {keyword.length > 0 ? (
                  <button onClick={() => setKeyword('')} type="button">
                    <Icon>close</Icon>
                  </button>
                ) : (
                  <Icon>search</Icon>
                )}
              </InputRightAddon>
            </InputGroup>
          </div>
          <div className="h-full overflow-y-auto">
            <SubjectFilterResult
              keyword={keyword}
              phase={selectedFase}
              phaseGroup={selectedFaseGroup}
              selectedSubject={internalSelectedSubject}
              onSelectedSubjectChange={(subject) => {
                setInternalSelectedSubject(subject)
              }}
            />
          </div>
        </div>
        {isShowButton && (
          <div className="fixed bottom-0 h-[80px] w-full max-w-[576px] border-t border-disabled bg-white p-4">
            <Button
              fullWidth
              className="!h-full"
              onClick={() => {
                setSelectedSubject(internalSelectedSubject)
                close()
              }}
            >
              Pilih
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  )
}

export default MapelSheet
